var EProductPlanAdditionalTeaching = /*#__PURE__*/ function(EProductPlanAdditionalTeaching) {
    EProductPlanAdditionalTeaching["CancellationPolicy"] = "cancellationPolicy";
    EProductPlanAdditionalTeaching["ExclusionOfRevocation"] = "exclusionOfRevocation";
    EProductPlanAdditionalTeaching["NoLegalAdviceContractWork"] = "noLegalAdviceContractWork";
    EProductPlanAdditionalTeaching["DpaForPayedSupport"] = "dpaForPayedSupport";
    return EProductPlanAdditionalTeaching;
}(EProductPlanAdditionalTeaching || {});
export { EProductPlanAdditionalTeaching };
